import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import PlantingsMap from "./components/PlantingsMap";
import ResultsSection from "./components/ResultsSection";
import FestivalsSection from "./components/FestivalsSection";
import WhyTreesSection from "./components/WhyTreesSection";
import HowToPlantSection from "./components/HowToPlantSection";
import AboutUsSection from "./components/AboutUsSection";
import GallerySection from "./components/GallerySection";
import ContactsSection from "./components/ContactsSection";
import Footer from "./components/Footer";
import PaymentModal from "./components/PaymentModal";
import { initFacebookPixel } from "./utils/fbPixel";

import { useHead } from "./seo/useHead";
import SeoOrg from "./seo/SeoOrg";

import { EventsList } from "./components/Events/EventsList";
import { EventDetail } from "./components/Events/EventDetail";
import BlogList from "./pages/BlogList";
import BlogPost from "./pages/BlogPost";
import { AdminLogin } from "./admin/AdminLogin";
import { AdminDashboard } from "./admin/AdminDashboard";

function HomePage() {
    const [paymentStatus, setPaymentStatus] = useState<"success" | "failure" | null>(null);
    const [paymentType, setPaymentType] = useState<"donation" | "ticket">("donation");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const pay = params.get("pay");
        const ticket = params.get("ticket");

        if (pay === "success" || pay === "failure") {
            setPaymentStatus(pay);
            setPaymentType("donation");
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (ticket === "success" || ticket === "failure") {
            setPaymentStatus(ticket);
            setPaymentType("ticket");
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    useHead({
        title: "Жашыл дем — посадка деревьев в Кыргызстане",
        metas: [
            { name: "description", content: "Одно дерево может изменить мир вокруг" },
            { property: "og:type", content: "website" },
            { property: "og:title", content: "Жашыл дем — посадка деревьев в Кыргызстане" },
            { property: "og:description", content: "Одно дерево может изменить мир вокруг" },
            { property: "og:url", content: "https://jashyl.com/" },
            { property: "og:image", content: "https://jashyl.com/og/jashyl.png" },
            { name: "twitter:card", content: "summary_large_image" }
        ],
        links: [{ rel: "canonical", href: "https://jashyl.com/" }]
    });

    return (
        <>
            <SeoOrg />
            <Header />
            <main>
                <HeroSection />
                <PlantingsMap />
                <ResultsSection />
                <HowToPlantSection />
                <FestivalsSection />
                <WhyTreesSection />
                <AboutUsSection />
                <GallerySection />
                <ContactsSection />
            </main>
            <Footer />

            {paymentStatus && (
                <PaymentModal type={paymentStatus} paymentType={paymentType} onClose={() => setPaymentStatus(null)} />
            )}
        </>
    );
}

function App() {
    useEffect(() => {
        initFacebookPixel();
    }, []);

    useEffect(() => {
        const host = window.location.hostname
        const isProd = host === 'jashyl.com' || host === 'www.jashyl.com'
        if (!isProd) {
            const meta = document.querySelector('meta[name="robots"]')
            if (meta) meta.setAttribute('content', 'noindex, nofollow')
        }
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/events" element={<EventsList />} />
                <Route path="/events/:slug" element={<EventDetail />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
            </Routes>
            <Analytics />
            <SpeedInsights />
        </>
    );
}

export default App;
